import { Stack, Typography, Divider } from '@mui/material';
import { BackupPolicyType } from '@repo/api-gw-sdk';

import { isPitrPolicyType, isStandardPolicyType } from './backupPoliciesTypes';
import { SupportedResourceTypesText } from './supportedResourceTypesText';
import { useBackupPolicyAvailableTypes } from './useBackupPolicyAvailableTypes';

export const BackupPolicySupportedDisclaimer = ({
  policyType,
}: {
  policyType: BackupPolicyType;
}) => {
  return (
    <>
      <Stack gap='2px'>
        <div />
        <Stack
          alignItems='center'
          className='bg-(--mui-palette-background-section)'
        >
          <BackupPolicyTypeDescription policyType={policyType} />
        </Stack>
        <Divider />
      </Stack>
    </>
  );
};

export const BackupPolicyTypeDescription = ({
  policyType = BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD,
  showForPitr = true,
}: {
  policyType?: BackupPolicyType;
  showForPitr?: boolean;
}) => {
  const resourceTypes = useBackupPolicyAvailableTypes()[policyType];

  if (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY ||
    isStandardPolicyType(policyType)
  ) {
    return (
      <Typography padding='12px 0px'>
        {`${policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY ? 'High-frequency' : 'Standard'} backup policy${policyType === BackupPolicyType.BACKUP_POLICY_TYPE_NATIVE_STANDARD ? ' • Storing snapshots in source account' : ''} • Available for `}
        <SupportedResourceTypesText resourceTypes={resourceTypes} />
      </Typography>
    );
  }

  if (showForPitr && isPitrPolicyType(policyType)) {
    return (
      <Typography
        padding='12px 40px'
        align='center'
        className='bg-(--mui-palette-background-section)'
      >
        Point-in-time recovery backup policy.
      </Typography>
    );
  }

  return null;
};
